/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */
import type {
  AdminV1OrganizationsPaymentsLogListParams,
  PaginatedPaymentsLogList,
  PaymentsLogDetail
} from '.././model';

import adminV1OrganizationsPaymentsLogListMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsLogRetrieveMutator from '../../shared/services/axios-client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsPaymentsLogList = (
    organizationId: number,
    params?: AdminV1OrganizationsPaymentsLogListParams,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsLogListMutator<PaginatedPaymentsLogList | Blob>>,) => {
      return adminV1OrganizationsPaymentsLogListMutator<PaginatedPaymentsLogList | Blob>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/log/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Retrieve detailed information about a specific payment including installment info, player details, and transaction history.
 * @summary Get payment detail
 */
export const adminV1OrganizationsPaymentsLogRetrieve = (
    organizationId: number,
    id: string,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsLogRetrieveMutator<PaymentsLogDetail>>,) => {
      return adminV1OrganizationsPaymentsLogRetrieveMutator<PaymentsLogDetail>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/log/${id}/`, method: 'GET'
    },
      options);
    }
  export type AdminV1OrganizationsPaymentsLogListResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsLogList>>>
export type AdminV1OrganizationsPaymentsLogRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsLogRetrieve>>>
